var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.557525 1.97763C0.24742 1.0278 1.23676 0.175514 2.13056 0.622166L19.8786 9.49318C20.7079 9.90832 20.7079 11.0917 19.8786 11.5064L2.13056 20.3779C1.23676 20.8245 0.24742 19.9717 0.557525 19.0224L3.33697 10.4995L0.557525 1.97763ZM4.44885 11.1252L1.83896 19.1255L19.0953 10.5L1.83896 1.87409L4.44835 9.87481H12.8727C13.0385 9.87481 13.1976 9.94068 13.3148 10.0579C13.4321 10.1752 13.4979 10.3342 13.4979 10.5C13.4979 10.6658 13.4321 10.8249 13.3148 10.9421C13.1976 11.0594 13.0385 11.1252 12.8727 11.1252H4.44885Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.13dfc1d885ea9cbfdb21d0e2c7afbd78.svg";
export { ForwardRef as ReactComponent };